<ng-container *ngIf="authenticated">
    <app-travelagent-desktop-nav *ngIf="isTravelAgent">
        <ng-content select="[slot=ta-search]"></ng-content>
    </app-travelagent-desktop-nav>
    <app-consumer-desktop-nav *ngIf="isConsumer">
        <ng-content select="[slot=consumer-search]"></ng-content>
    </app-consumer-desktop-nav>
    <app-desktop-nav *ngIf="isOther"></app-desktop-nav>
    <app-mobile-nav *ngIf="isOther" (toggleNav)="navOpen = true"></app-mobile-nav>
    <ng-content></ng-content>
</ng-container>

<app-public-nav *ngIf="!authenticated" [logoUrl]="publicNavLogoUrlOverride"></app-public-nav>
